var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100vw","height":"100vh","background-color":"black"}},[_c('div',{staticClass:"layer1"}),_c('div',{staticClass:"layer2"}),_c('div',{staticClass:"layer3"}),_c('div',{staticClass:"layer4"}),_c('div',{staticClass:"layer5"})])
}]

export { render, staticRenderFns }